/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_Subscription_DataInputs */



/**
* | output |
* | --- |
* | "Loading subscription data..." |
*
* @param {Loading_Subscription_DataInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const loading_subscription_data = /** @type {((inputs?: Loading_Subscription_DataInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_Subscription_DataInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chargement des données d'abonnement...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Abonnementdaten werden geladen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento dati abbonamento in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузка данных подписки...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargando datos de suscripción...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在加载订阅数据……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サブスクリプションデータを読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्यता डेटा लोड हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregando dados de assinatura...")
	return /** @type {LocalizedString} */ ("Loading subscription data...")
});